export default () => {
  return [
    {
      'id':'1',
      'show':'1',
      'headline':'Narcissus',
      'textShort':'Filmen om Narcissus handlar om förnekelse och om sitt eget ansvar för det egna livet',
      'textLong':[
        {'paragraph': '<span class="CapUp">Historien om  Narcissus</ span> <span class="CapDown">är gott och väl 2500 år gammal och tillhör den grekiska mytologin.</span>'},
        {'paragraph': 'Handlingen kretsar kring en man som blev dömd att förälska sig i egen spegelbild, vilket gjorde att han inte kunde slita blicken från sitt ansikte, vilket i sin tur slutade med att han tynade bort.'},
        {'paragraph': 'I min uppdaterade version bär Narcissus på alla de drag en stark självälskande person har. Hans självcentrering har gjort att han stötts bort av hans vänner. Som den narcissistiska person han är, förnekar han sitt eget ansvar och skyller på alla andra. Han har satt ett ultimatum till sina vänner - om de inte dyker upp så kommer han att ta sitt liv. Självklart så tror han att de ska dyka upp och rädda honom och därmed kommer de att bekräfta Narcissus tro att de älskar honom mer än livet.'},
        {'paragraph': 'Den enda som dyker upp är Broder - spegelbilden - den enda som säger sanningen till Narcissus.'},
        {'paragraph': 'Filmen tog två dagar att filma med en RED-kamera. Platsen är en solig och lummig äng vid Sjöändan utanför Norrtälje.'},
        {'paragraph': 'Huvudrollsinnehavaren <a href="http://www.pontusolgrim.se">Pontus Olgrim<a> fick pris för bästa manliga huvudroll i Indie Fest 2012.'}
      ],
      'textPin':'Filmen om Narcissus handlar om förnekelse och om sitt eget ansvar för det egna livet. ',
      'caseInputDate':'2015-02-23',
      'showArt':'0',
      'quote':'Steffo är artistiskt begåvad med stor fantasi parat med en stark förmåga till avslut. Han är stark i hela produktionskedjan - id\u00e9, manusskrivande, produktion, fotoregi och postproduktion.',
      'quoteName':'Pontus Olgrim<BR>Producent och skådespelare','type':'Kortfilm, 11min',
      'colorSpace':'1',
      'employer':'1',
      'client': '1',
      'imgCollage':'9',
      'imgCollageSetup':'1,13,5,3',
      'tools':'15,12',
      'tasks':'1,2,6,24,37',
      'format':'RED',
      'year':'2010',
      'link': [
        {
          'title': 'Se filmen Narcissus',
          'icon': 'youtube',
          'url': 'https://youtu.be/LqUI8iE8BsE'
        }
      ],
      'imgThumb':{
        'img1': 'film/narcissus/2x1_narcissus_01.jpg',
        'img2': 'film/narcissus/1x1_narcissus_01.jpg',
        'img3': 'film/narcissus/1x1_narcissus_02.jpg',
      },
      'categories': {
        'film': true,
      }
    },
    {
      'id':'2',
      'show':'1',
      'headline':'Värderingsmannen',
      'textShort':'En film en cynisk värderingsman och hans tankar om människor',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Filmen Värderingsmannen</ span> <span class="CapDown">låg i byrålådan i nio år innan den blev färdig. Jag kan så här i efterhand säga att jag är glad över att den fick marineras ett par år - den behövde ett speciellt format och språk som den inte hade från början.</span>'},
        {'paragraph': 'Värderingsmannen handlar om en man som värderar människors hem. Han har blivit cynisk i sitt arbete och anser att alla människor är lika. Dock får han insikt om vi alla även har något som gör oss till individer.'},
        {'paragraph': 'Formspråket kommer från den franska vågens filmer från 60-talet. Allt inspelningsljud är borttaget och ersatt med foley-ljud, som jag jag då själv har gjort merparten av. (Det enda ljudet jag inte gjorde själv var ett fotoblixtljud från en gammal lampblixt.)'},
        {'paragraph': 'Filmen tog två och en halv dag att filma. Det var bara jag och skådespelaren på plats. Jag satte ljuset och filmade. Regisserade gjorde vi tillsammans. Merparten av klipparbete gjorde jag men vi har gått igenom klippningen tillsammans. Förutom att sätta allt till svartvitt har jag även gjort mindre VFX-arbeten.'},
        {'paragraph': 'Jag är riktigt nöjd med resultatet och särskilt under den korta tid den är producerad. Kostnaden är, förutom arbetstiden, inte mer än max 300kr.'},
        {'paragraph': 'Värderingsmannen spelas av den alltid lika fantastiske Anders Menzinsky.'}
      ],
      'textPin':'Värderingsmannen handlar om en man som värderar människors hem.',
      'caseInputDate':'2015-06-23',
      'showArt':'1',
      'quote':'Steffo är en seriös och kompetent medarbetare. Hans öga för noggrannhet och detaljer gör att resultat alltid blir förstklassigt. Hans id\u00e9rikedom och påhittighet gör att arbetet alltid känns glädjefyllt och spännande!',
      'quoteName':'Anders Menzinsky<BR>Skådespelare',
      'type':'Kortfilm, 10min',
      'colorSpace':'3',
      'employer':'1',
      'client': '1',
      'imgCollage':'7',
      'imgCollageSetup':'12,9,10,11',
      'tools':'1,3,12,5,13,15',
      'tasks':'28,1,2,5,11,12,16,22,23,24,34,4,35,36',
      'format':'MPEG-4H.264',
      'year':'2015',
      'link': [
        {
          'title': 'Se filmen Värderingsmannen',
          'icon': 'vimeo',
          'url': 'https://vimeo.com/148868806'
        }
      ],
      'imgThumb': {
        'img1': 'film/varderingsmannen/2x1-varderingsmannen-01.jpg',
        'img2': 'film/varderingsmannen/2x2-varderingsmannen-03.jpg',
        'img3': 'film/varderingsmannen/1x1-varderingsmannen-02.jpg',
      },
      'categories': {
        'film': true,
      }
    },
    {
      'id':'3',
      'show':'1',
      'headline':'Amalia',
      'textShort':'En film baserad på den sanna historien om Amalia Meuller från Halmstad och hennes tre friare',
      'textLong':[
        {'paragraph': '<span class=\'CapUp\'>Filmen om Amalia<span> <span class="CapDown">baseras på en sann historia om Amalia Meuller från Halmstad som efter att ha fått tre stycken friarbrev, lät sin bästa väninna välja friare. Amalia gifte sig med en av friarna, Carl-Magnus Larsson.</span>'},
        {'paragraph': 'Min bror producerade filmen och frågade mig i fall jag var intresserad av att skriva manuset och självklart ville jag det. Amalias far är vår stamfader på släktträdet, så det kändes lite personligt ansvar att få till ett bra manus. Själva händelsen är bara ett par meningar i släktboken, så det blev en utmaning att fylla i luckorna och väva samman en intressant historia.'},
        {'paragraph': 'Den största utmaningen var att få till dialogerna a la 1800-tal, utan att det kändes konstlat. Den största aha-upplevelsen var att man faktiskt pratade på nästan samma sätt då som nu.'},
        {'paragraph': 'Resultatet blev en kortfilm på tjugo minuter inspelad till stor del i Halmstad. Mycket tid har lagts ner på att hitta rätta scenografi och kläder.'},
        {'paragraph': 'Produktionstiden från att jag fick uppdraget i min hand till filminspelningen började var cirka tio månader, så det var snabba ryck att få den färdig.'}
      ],
      'textPin':'Filmen om Amalia baseras på en sann historia om Amalia Meuller från Halmstad.',
      'caseInputDate':'2015-02-24',
      'showArt':'0',
      'quote':'Steffo Dimfelt sätter lupp på saker i vår vardag, ofta på ett slagfärdigt sätt och med en komisk absurd knorr. I vårt arbete med Amalia var det något annorlunda då historien baserades på verkliga händelser 1890-talets Tylösand. Men i det ganska allvarliga dramat kan man ändå skönja Steffo Dimfelts karaktäristiska värme och humor.',
      'quoteName':'Mikael Berg<BR>Regissör',
      'type':'Kortfilm, 23min',
      'colorSpace':'1',
      'employer':'3',
      'client': '3',
      'imgCollage':'11',
      'imgCollageSetup':'8,6,7,14',
      'tools':'15',
      'tasks':'1',
      'format':'RED',
      'year':'2010',
      'link': [
        {
          'title': 'Se filmen Amalia',
          'icon': 'vimeo',
          'url': 'http://vimeo.com/m/60997271'
        }
      ],
      'imgThumb':{
        'img1': 'film/amalia/3x1_amalia02.jpg',
        'img2': 'film/amalia/2x1_amalia01.jpg',
        'img3': 'film/amalia/1x1_amalia03.jpg',
      },
      'categories': {
        'film': true,
      }
    },
    {
      'id':'4',
      'show':'1',
      'headline':
      'Klädkatalog',
      'textShort':'Foto till Friskis&Svettis klädkataloger',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Jag har producerat alla produktbilder<span> <span class="CapDown">till samtliga Friskis&Svettis-kataloger ända sedan 2005. Till Höst 2014- och Vår 2015-katalogerna fick jag även fota miljöbilderna på plats i en av Friskis-lokalerna i Stockholm.</span>'},
        {'paragraph': 'Modellerna är utvecklingsansvariga på Friskis, och de fick gå loss på diverse stationer i lokalen.'},
        {'paragraph': 'Fotona fick ett modernt Instagram-stuk över sig, men retuschen är faktiskt minimal. Egentligen bara en gul och lila färgsättning och en polaroid-ram.'},
        {'paragraph': 'Eftersom de bilderna skulle kännas spontana gav vi inte modellerna mer anvisningar än: \'Gör som du normalt skulle göra\'. Porträttbilderna är något mer arrangerade. Den stående anvisningen var: \'Titta dit\' och så fick jag springa runt och fota.'},
        {'paragraph': 'Jag har bara fått bra respons över just den spontana bildkänslan. Jag jobbade mycket med kort skärpedjup vilket gjorde att man kom nära inpå modellerna.'}
      ],
      'textPin':'Fotning och slutoriginal av katalog.',
      'caseInputDate':'2015-03-16',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Katalog',
      'colorSpace':'2',
      'employer':'4',
      'client': '6',
      'imgCollage':'10',
      'imgCollageSetup':'15,18,16,17',
      'tools':'1,4,16',
      'tasks':'9,12,16,17,18,19,22,23',
      'format':'-',
      'year':'2014',
      'imgThumb': {
        'img1': 'print/Friskis/KatalogV15/2x1FriskisV15_4.jpg',
        'img2': 'print/Friskis/KatalogV15/2X2FriskisV15_1.jpg',
        'img3': 'print/Friskis/KatalogV15/1x1FriskisV15_2.jpg',
      },
      'categories': {
        'print': true,
        'photo': true,
      }
    },
    {
      'id':'5',
      'show':'1',
      'headline':'Klädkatalog',
      'textShort':'Katalog till Ahlsells personalkläder',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Till Ahlsells katalog<span> <span class="CapDown">fick jag helhetsuppdraget att ta fram produktkatalogen.</span>'},
        {'paragraph': 'Förutom att vara AD och originalare av katalogen, tog jag även fram ett koncept för miljöbilderna. Koncepetet blev en dag i en butik, där bilderna var olika tidsmässiga nedslag och situationer. Jag jobbade tillsammans med fotografen på plats i Ahlsell-butik, där tre anställad Ahlsell-medarbetare agerade modeller.'},
        {'paragraph': 'Dessutom fotade jag alla kläderna på modeller i studio. Det var hektiskt för jag jobbade parallellt med Svenska Spels katalog.'}
      ],
      'textPin':'Katalog till Ahlsells personalkläder. ',
      'caseInputDate':'2015-03-28','showArt':'0',
      'quote':null,'quoteName':'',
      'type':'Katalog',
      'colorSpace':'2',
      'employer':'2',
      'client': '2',
      'imgCollage':'9',
      'imgCollageSetup':'19,20,21,23',
      'tools':'1,4,16',
      'tasks':'9,12,16,17,18,19,23',
      'format':'210mm x 250mm<BR>40 sidor',
      'year':'2007',
      'imgThumb': {
        'img1': 'print/Ahlsell/Klader-katalog/2x1-Ahlsell01.jpg',
        'img2': 'print/Ahlsell/Klader-katalog/2x2-Ahlsell02.jpg',
        'img3': 'print/Ahlsell/Klader-katalog/1x1-Ahlsell01.jpg',
      },
      'categories': {
        'print': true,
        'photo': true,
      }
    },
    {
      'id':'6',
      'show':'1',
      'headline':'Logotyp',
      'textShort':'Logotyp till elskotern Elektro 1',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Ecoskoter startade upp en import<span> <span class="CapDown">av elskotrar till Sverige. De behövde en logotype som skulle sättas på sidan av skotrarna. Premisserna var att den skulle kännas \'vespa\' samtidig som den skulle spegla att skotern gick på el.</span>'},
        {'paragraph': 'Logotypen fick klassisk framåtlutad våg, inspirerad av Leica och Campagnolo, som avslutas med en illustrerad stickkontakt. Klassiskt möter modernt.'}
      ],
      'textPin':'Logotyp till elskotern Elektro 1.',
      'caseInputDate':'2015-04-13',
      'showArt':'0',
      'quote':null,'quoteName':'',
      'type':'Logotype',
      'colorSpace':'3',
      'employer':'5',
      'client': '5',
      'imgCollage':'3',
      'imgCollageSetup':'25,26,27',
      'tools':'2',
      'tasks':'28,10,26,27',
      'format':'-',
      'year':'2010',
      'imgThumb': {
        'img1': 'other/Elektro/2x1-Elektro02.jpg',
        'img2': 'other/Elektro/2x1-Elektro03.jpg',
        'img3': 'other/Elektro/2x2-Elektro01.jpg',
      },
      'categories': {
        'other': true,
      }
    },
    // {
    //   'id':'7',
    //   'show':'1',
    //   'headline':'Detaljbilder',
    //   'textShort':'\'The Devil is in the details\' brukar man ju säga. Att fota produkter innebär inte bara att ta en bild på en produkt.',
    //   'textLong':'<span class=\'CapUp\'>\'The Devil is in the details\'<span> <span class="CapDown">brukar man ju säga. Att fota produkter innebär inte bara att ta en bild på en produkt - man måste även förstå vad som avbildas. När man tar produktbilder ser man oftast hela produkten med en vit bakgrund. Detta för att en sådan bild är enkel att använda till en massa olika medier. Det är tydligt och man förstår vad det är man ser. <BR><BR>Men ibland behöver man ta ett par extra bilder. Oftast för att show detaljerna på produkten. Inget konstigt med det. <BR><BR>Mitt jobb blir genast lite roligare och utmanande. Att få gå närmare in i produkten och show dess \'själ\'. Sådant tycker jag är kul. Vissa gånger får man verkligen vända och vrida på både bildvinkel och produkt innan det blir rätt. Andra gånger lyckas man på första försöket. <BR><BR>När man väl är klar och har en jättebra bild, har man inte bara förtydligat produkten, man förmodligen även höjt värdet på produkten genom bilden.</span>',
    //   'textPin':'\'The Devil is in the details\' brukar man ju säga.',
    //   'caseInputDate':'2015-04-14',
    //   'showArt':'0',
    //   'quote':null,
    //   'quoteName':'',
    //   'type':'Produktfoto',
    //   'colorSpace':'1',
    //   'employer':'4',
    //   'imgCollage':'4',
    //   'imgCollageSetup':'28,29,30,31',
    //   'tools':'16,17,1',
    //   'tasks':'17,19,23,12,16',
    //   'format':'Canon RAW',
    //   'year':'2014',
    //   'link':null,
    //   'linkName':null,
    //   'imgThumb':''
    // },
    {
      'id':'8',
      'show':'1',
      'headline':'Klädkatalog',
      'textShort':'Svenska Spels klädkatalog',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Svenska Spel behövde en egen kollektion<span> <span class="CapDown">som spelombuden skulle ha på sig. Varje spel fick en egen linje, baserad på spelets färg som samtidigt hölls helhet genom att alla plagg hade samma uppbyggnad vad det gäller revär och stripes.</span>'},
        {'paragraph': 'Mitt uppdrag var att ta produktfoton på hela kollektionen, på modell. Vi använde oss av ett par anställda på byrån.'},
        {'paragraph': 'Efter att alla produktfotona var tagna var det min uppgift att säkra upp och korrigera färgerna. Dels skulle alla färgerna hålla ihop med övriga spelens färger, dels skulle färgerna stämma på de olika plaggen.'},
        {'paragraph': 'Utmaningen var att hålla tempo och planera fotograferingen. Alla plaggen var inte klara och en del av dem fick färgkorrigeras. Dessutom hade jag dubbel deadline eftersom jag samtidigt jobbade med en katalog till Ahlsell.'}
      ],
      'textPin':'Profilkollektionkatalog till Svenska Spel.',
      'caseInputDate':'2015-04-14',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Katalog',
      'colorSpace':'2',
      'employer':'2',
      'client': '15',
      'imgCollage':'8',
      'imgCollageSetup':'33,34,35,32',
      'tools':'16,1,4',
      'tasks':'9,12,16,17,18,19,23',
      'format':'210mm x 210 mm<BR>36 sidor',
      'year':'2007',
      'imgThumb': {
        'img1': 'print/SvenskaSpel/katalog/2x1-SvS-Katalog01.jpg',
        'img2': 'print/SvenskaSpel/katalog/2x2-SvS-Katalog02.jpg',
        'img3': 'print/SvenskaSpel/katalog/1x1-SvS-Katalog03.jpg',
      },
      'categories': {
        'print': true,
        'photo': true,
      }
    },
    {
      'id':'9',
      'show':'1',
      'headline':'Webbsidor',
      'textShort':'Historien om Metallicas webbsidor 1999-2003.',
      'textLong': [
        {'paragraph': 'span class=\'CapUp\'>Sommaren 1999 ringde Niclas Swanlund<span> <span class="CapDown">mig från San Fransisco. Vi kände inte varandra. Han hade fått mitt nummer av en gemensam vän. Han ville uppdatera Metallicas samtliga webbsidor - Metallica.com, MetOnTour.com och MetClub.com. "Javisst!", sa jag. "Inga problem!" Så här i efterhand var det tur att jag inte visste vilken vansinnig idé det var.</span>'},
        {
          'subtitle': 'Bakgrund',
          'paragraph': 'Niclas jobbade som turnéfotograf och ansvarig för Metallica på webben. På den tiden, i slutet av 90-talet, var webben fortfarande något som flödade av fria tankar, drömmar och något som bara var roligt att hålla på med. Niclas hade dock ett mål - han ville göra den bästa hårdrockssidan som fanns.'
        },
        {'paragraph': 'Vi kollade runt och det fanns faktiskt inga sidor som var särskilt bra, förutom Iron Maiden och Ozzy Osburn. Att bygga sitt varumärke på webben var ett okänt begrepp. Det vara knapp att folk visste vad webben var för något.'},
        {
          'subtitle': 'Planen',
          'paragraph': 'Vår idé vara som sagt att bygga den bästa hårdrockssidan. Metallicas fans är mycket dedikerade till bandet och vår plan var att ge dem ALLT som Metallica har gjort. Att ge cred till fansen är något som är viktigt för bandet och det var det vi ville spegla på sidorna. För det var inte bara en webbsidor som skulle göras, utan tre stycken.'
        },
        {
          'subtitle': 'Grundarbetet',
          'paragraph': 'Jag hade byggt en del i Flash och runt 1999-2000 var det den teknik som var det häftigaste man kunde göra. Niclas hade inte själv några invändningar, hans inställning var bara att sidan skulle ligga i tekniskt framkant, vilket passade bra med Flashtekniken.'
        },
        {'paragraph': 'Tillsammans skissade vi upp sidan. Metallica hade då precis släppt sitt album S&M samarbetade med Anton Corbijn till sina officiella bandfoton. Dessa manér kom att spegla i sidornas grafik.'},
        {
          'subtitle': 'Utförande',
          'paragraph': 'Hela hösten 1999 och våren 2000 satt jag mer eller mindre varje kväll mellan 21-03, eftersom klockan då var 9 på morgonen på amerikanska västkusten, och jobbade med sidan. Nuförtiden skulle det vara ett helt team som utvecklade sidan, men då var det bara jag. Niclas satt i San Fransisco och styrde upp vad som behövdes och kom med allt material medan jag satte ihop sidorna så fort det gick.'
        },
        {'paragraph': 'Någon gång i mitten av hösten slog det Niclas att det här med Flash inte var så användarvänligt. Man ska komma ihåg att i slutet av 90-talet fanns det ett stort problem i att alla besökare inte hade en modern webbläsare och om de hade det, så var de tvungna att ladda hem den senaste Flash-läsare. Vår lösning blev en Flash-sida och en HTML-variant. Och eftersom detta var innan ASP slagit igenom ordentligt, så fick jag hårdkoda varje sida för sig.'},
        {'paragraph': 'idag hade jag jobbat med databaser och mallade sidor, men då hade jag ingen aning om hur man programmerade. Dessutom fungerade Flash utan att man behövde scripta någonting. Problemet var att allt blev fruktansvärt tungrott.'},
        {'paragraph': 'Särskilt minns jag att alla låtar från alla album skulle vara med som provlyssning i både RealAudio och Quicktime. Att lista upp låtarna i HTML gick väl hyfsat snabbt, men i Flash var det inte roligt - jag vill minnas att den sida som man såg i Flash inte var samma som den som man såg i webbläsaren. Det innebar att jag manuellt fick justera varje sångrad för hand.'},
        {'paragraph': 'MetClub och MetOnTour var enklare. De gjordes inte i Flash. MetClub är fansens sida, och den fick en vit variant av den svart som var Metallica.com. MetOnTour är turnésidan och den fick dubbla sidor, för vi ville ha in lite rörliga bilder.'},
        {
          'subtitle': 'Slutförande',
          'paragraph': 'Strax innan sommaren 2000 blev allting klart. Vi var nöjda. Bandet var nöjda. Sidan fick ett enormt bra mottagande av fansen. Det var inte likt något som funnits i hårdrockssfären. Det mest galna var att allt var hårdkodat och gjort av två personen. Ibland tänker jag på den tanken - världens bästa hårdrocksband gjordes av två personen.'
        },
        {
          'subtitle': 'Efterspel',
          'paragraph': 'Men ibland blir det inte som man önskar. Under sommaren blev James inlagd på avgiftning och bandemedlemmarna behövde vara ifrån varandra. Alla deras uppdrag stoppades, så även lanseringsfesten. Tråkigt, men jag och min bror hade redan bokat resa och vi fick i varje fall tre veckor i USA. '},
        {'paragraph': 'Så här i efterhand är det fortfarande overkligt att jag har gjort Metallicas sida. Jag har träffat många diehard-fans som skulle vilja göra den. Ibland blir jag påmind om det och varje gång blir jag glad och stolt. Säga vad man vill om att det var 15 år sedan, men det var jag som gjorde det!'},
      ],
      'textPin':'Historien om Metallicas webbsidor 1999-2003.',
      'caseInputDate':'2015-04-16',
      'showArt':'0',
      'quote':'\'Fuckin\' great, man!\'',
      'quoteName':'James Hetfield, Sångare',
      'type':'Webbsidor',
      'colorSpace':'1',
      'employer':'6',
      'client': '9',
      'imgCollage':'9',
      'imgCollageSetup':'36,54,55,56',
      'tools':'1,10,14',
      'tasks':'7,8,10,16,38,39',
      'format':'HTML<BR>Flash',
      'year':'1999',
      'imgThumb': {
        'img1': 'web/Metallica/2x1-Metallica01.jpg',
        'img2': 'web/Metallica/2x2-Metallica02.jpg',
        'img3': 'web/Metallica/1x1-Metallica04.jpg',
      },
      'categories': {
        'web': true,
      }
    },
    {
      'id':'11',
      'show':'1',
      'headline':'Produktlansering',
      'textShort':'Inspirationsbilder till Skandias produktfolder',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>När Skandia gjorde om sin profil<span> <span class="CapDown">hade det föregåtts av en hel del turbulens. Man insåg att man behövde byta bort sin gamla kostym och paraply och föra in något nytt. Inget konstigt med det. Alla stora företag gör det med jämna mellanrum.</span>'},
        {'paragraph': 'Skandias nya profil var allt annat än företagsblå. Man tog en grön färg istället. Man tog fram en ny logotype med namnet Skandia och adderade ett kolon i silver efter namnet.'},
        {'paragraph': 'Vårt uppdrag blev att använda oss av kolona och färgerna på produkter. Det blev som ett mönster i både grund- och accentfärger.'},
        {'paragraph': 'För att riktigt vända blad, ville man även skapa ett event på sitt huvudkontor. Till detta event skapades en utställning och till denna utställning behövdes det en inspirerande folder med produkter. '},
        {'paragraph': 'För att göra en lång historia kort - jag fotade inspirationsbilderna till foldern och till säljmaterialet. Jag gjorde även förpackningar, ansvarade för webbshop och material till en lanseringsmonter för deras huvudkontor.'}
      ],
      'textPin':'Inspirationsbilder till Skandias produktfolder. ',
      'caseInputDate':'2015-04-17',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Inspirationsfoton',
      'colorSpace':'1',
      'employer':'2',
      'client': '12',
      'imgCollage':'3',
      'imgCollageSetup':'45,44,43',
      'tools':'16,1',
      'tasks':'12,16,17,19',
      'format':'-',
      'year':'2008',
      'imgThumb': {
        'img1': 'foto/Skandia/lansering/2x1-Skandia-lansering03.jpg',
        'img2': 'foto/Skandia/lansering/2x2-Skandia-Lansering01.jpg',
        'img3': 'foto/Skandia/lansering/2x1-Skandia-lansering02.jpg',
      },
      'categories': {
        'photo': true,
        'event': true,
      }
    },
    {
      'id':'10',
      'show':'1',
      'headline':'Produktaffisch',
      'textShort':'En affisch med plagg i 3D',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Affisch till Friskis<span> <span class="CapDown">föregås av att under mina tio år som jag jobbat med Friskis, så har det skickats ut kataloger. Förutom några år tidigare, det gjordes både en affisch och en katalog.</span>'},
        {'paragraph': 'Till Vår 16 tänkte produktansvarig att det skulle vara på sin plats att bara göra en affisch. I diskutionen kom vi även fram till att det var mycket nytt som skulle shows, men att plaggen inte fanns i produktion. Tanken blev att göra alla produkter i 3D, istället för att blanda foto på befintliga produkter med skisser.'},
        {'paragraph': 'På en månad modellerades plaggen, sattes på rätt textur och renderades. Resultatet användes till affisch och webshop.'},
      ],
      'textPin':'Plaggen i Friskis affisch gjordes helt i 3D.',
      'caseInputDate':'2015-04-16',
      'showArt':'1',
      'quote':null,
      'quoteName':'',
      'type':'Affisch',
      'colorSpace':'2',
      'employer':'4',
      'client': '6',
      'imgCollage':'10',
      'imgCollageSetup':'42,41,39,38',
      'tools':'20,1,3',
      'tasks':'13,12,15,20,16',
      'format':'594mmx840mm',
      'year':'2015',
      'imgThumb': {
        'img1': 'print/Friskis/AffischV16/2x1-Friskis-Affisch-06.jpg',
        'img2': 'print/Friskis/AffischV16/2x2-Friskis-Affisch-01.jpg',
        'img3': 'print/Friskis/AffischV16/2x2-Friskis-Affisch-05.jpg',
      },
      'categories': {
        'print': true,
        '3d': true,
      }
    },
    {
      'id':'12',
      'show':'1',
      'headline':'Informationspelare',
      'textShort':'Informationspelare till TeliaSoneras bolagsstämma',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Till varje bolagsstämma<span> <span class="CapDown">vill man som företag show upp det mest intressanta som hänt under året och saker som komma skall.</span>'},
        {'paragraph': 'Aktieägare kommer för att ta del av framtiden och bolagstämmor brukar var välbesökta, särskilt när det kommer till stora företag som exempelvis TeliaSonera.'},
        {'paragraph': 'Platser för 2004 års bolagsstämma var på Annexet vid Globen i Stockholm.<BR><BR>För att få ut maximal exponering på en begränsad yta, använde vi hexagonformade pelare. Som besökare kan man dels få en lättfattlig överblick över TeliaSoneras hela verksamhet, samtidigt som man slipper trängas i fall det är något man vill läsa mer om.'},
        {'paragraph': 'Pelarnas placering ger också ett flöde från själva lounge-delen in  till bolagstämmans sal.'},
      ],
      'textPin':'Informationspelare till TeliaSoneras bolagsstämma.',
      'caseInputDate':'2015-04-20',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Informationspelare',
      'colorSpace':'2',
      'employer':'7',
      'client': '17',
      'imgCollage':'7',
      'imgCollageSetup':'47,46,48,49',
      'tools':'1,2',
      'tasks':'9,10,16',
      'format':'-',
      'year':'2004',
      'imgThumb': {
        'img1': 'print/TeliaSonera/general_meeting/2x2-TeliaSonera-Hex-02.jpg',
        'img2': 'print/TeliaSonera/general_meeting/1x1-TeliaSonera-Hex-03.jpg',
        'img3': 'print/TeliaSonera/general_meeting/1x1-TeliaSonera-Hex-04.jpg',
      },
      'categories': {
        'print': true,
        'event': true,
      }
    },
    {
      'id':'13',
      'show':'1',
      'headline':'VIP-gåva',
      'textShort':'3D-skiss på Scandics VIP-gåva',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Ibland behövs det något extra.<span> <span class="CapDown">När det skulle göras en VIP-gåva till Scandics bästa gäster, gjorde jag skisser i 3D. Dels för att det är ett lätt sätt att visualisera produkten och dels för att show att vi verkligen såg detta som en VIP-gåva.</span>'},
        {'paragraph': 'Utifrån skisser från produktansvarig, ritade jag upp necessären i 3D. När jag fått godkänt av ansvarig, gick jag vidare i processen.'},
        {'paragraph': 'Jag tog textur från en provbit och slutligen renderade jag ut skissen.'},
        {'paragraph': 'om slutlig touch ritade jag upp en bit av ett badrum och satte jag in necessären där.'},
      ],
      'textPin':'3D-skiss på Scandics VIP-gåva.',
      'caseInputDate':'2015-04-20',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'3d-skiss',
      'colorSpace':'1',
      'employer':'2',
      'client': '11',
      'imgCollage':'9',
      'imgCollageSetup':'53,50,51,52',
      'tools':'3,1',
      'tasks':'13,4,12,15,16,19,20,23',
      'format':'-',
      'year':'2011',
      'imgThumb': {
        'img1': '3d/Scandic/vip/2x1-Scandic-Necessar-04.jpg',
        'img2': '3d/Scandic/vip/1x1-Scandic-Necessar-01.jpg',
        'img3': '3d/Scandic/vip/2x1-Scandic-Necessar-04.jpg',
      },
      'categories': {
        '3d': true,
      }
    },
    {
      'id':'14',
      'show':'1',
      'headline':'Serviceshop',
      'textShort':'En shoplösning till Swedbanks Servicelager',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Att göra enkla lösningar<span> <span class="CapDown">som blir bra, kräver kunskap. När Swedbank ville ha en beställningslösning till sin interna serviceshop på huvudkontoret, skulle den närmaste lösningen vara att ta en befintlig shop och göra en variant av den. Detta skulle bli både oeffektiv både i kostnad och i arbete. Istället skissade jag upp ett förslag som gjorde det snabbt och enkelt  att beställa och adminstrera.</span>'},
        {'paragraph': 'Swedbank har ett tjugotal VIP-produkter som ligger internt på huvudkontoret. Som anställd kan man beställa och hämta ut en produkt på Servicelagret. Denna beställning ville man göra effektivare genom att man skulle kunna beställa via mejl.'},
        {'paragraph': 'Min lösning blev ett enkelt formulär som vid beställning skickade bekräftelser till beställaren och till en central mejladress. Detta gjorde att Servicelagret fick bättre kontroll över vad som ska hämtas. Dessutom lade jag till en bekräftelse till produktleverantören och en byggde en enkel administrationssida. Självklart gjordes allt responsivt.'}
      ],
      'textPin':'En shoplösning till Swedbanks Servicelager.',
      'caseInputDate':'2015-04-29',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Webshop',
      'colorSpace':'1',
      'employer':'4',
      'client': '14',
      'imgCollage':'2',
      'imgCollageSetup':'57,58',
      'tools':'7,8,9,11,19',
      'tasks':'7,8,29',
      'format':'Responsiv webb',
      'year':'2015',
      'imgThumb': {
        'img1': 'web/Swedbank/Internshop/2x2Swedbank-Shop01.jpg',
        'img2': 'web/Swedbank/Internshop/2x2Swedbank-Shop02.jpg',
        'img3': 'web/Swedbank/Internshop/2x2Swedbank-Shop01.jpg',
      },
      'categories': {
        'web': true,
      }
    },
    {
      'id':'15',
      'show':'1',
      'headline':'Förpackning och glas',
      'textShort':'Grafisk design till förpackning och whiskeyglas',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Jag hade knappt jobbat två månader<span> <span class="CapDown">på Stadium Promotion när jag fick uppdraget att göra grafisk design till både förpackning och whiskeyglas. Glasen var VIP-gåvor som skulle delas ut vid speciella event.</span>'},
        {'paragraph': 'Bakgrunden var att Johnnie Walker sponsrade McLaren Mercedes förare Kimi Raikkonen. Man hade dessutom blivit Formula 1 officiella whiskey. Johnnie Walker ville ha en racingkänsla i förpackningen och att glasen skulle kännas lite exklusiva.'},
        {'paragraph': 'Jag gjorde ett par varianter på Kimi på förpackningen och jag tog fram ett glas där hans autograf skulle blästras in. Efter några turer hos kund blev det tyvärr ingen autograf och blästringen blev av tidsskäl en silvrig etikett med Johnnie Walkers logotype. <BR><BR>Det trevliga är att jag lyckades få till logotypeens placering. Dess överkant är en indikator på ca 2cl härlig Black Label.'},
        {'paragraph': 'Trots att det har gått så lång tid sedan jag gjorde glasen, är det fortfarande ett av de jobb som jag är mest stolt över.'},
      ],
      'textPin':'Grafisk design till både förpackning och whiskeyglas.',
      'caseInputDate':'2015-05-08',
      'showArt':'0',
      'quote':null,'quoteName':'',
      'type':'Förpackning',
      'colorSpace':'2',
      'employer':'2',
      'client': '7',
      'imgCollage':'6',
      'imgCollageSetup':'61,62,63',
      'tools':'1,2,4',
      'tasks':'9,10,12,16,27',
      'format':'Förpackning<BR>Whiskeyglas',
      'year':'2005',
      'imgThumb': {
        'img1': 'print/JW/whiskey/2x1-JW-01.jpg',
        'img2': 'print/JW/whiskey/2x1-JW-Whiskey-03.jpg',
        'img3': 'print/JW/whiskey/2x2-JW-Whiskey-04.jpg',
      },
      'categories': {
        'print': true,
      }
    },
    {
      'id':'16',
      'show':'1',
      'headline':'Illustrationer',
      'textShort':'Illustrationer till sportflaska och musmatta',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Ibland blir jobbet både enkelt och roligt.<span> <span class="CapDown">Det behövdes några illustrationer på produkter till Telia som bland annat använder sig av heldragna linjer som ritar upp grafiska bilder. Mycket stilfull. Och utmanande.</span>'},
        {'paragraph': 'Kundansvarig behövde en sportflaska med ett sportmotiv och en musmatta med en datormus. Helst skulle linjen inte brytas, men det var okej om det inte märktes. Eftersom jag helst inte gör saker halvhjärtat, så var målet att göra heldragna linjer solklart.'},
        {'paragraph': 'När man gör ett sådant här jobb verkar det alltid enkelt till en början, men det ställer krav på kreativt tänk - Linjen får inte var för tjock, inte vara för nära andra delar, den ska sitta ihop på ett vettigt sätt och framför allt ska man se vad det föreställer.'},
        {'paragraph': 'Som vanligt blir det många skisser innan slutoriginalet kan skickas iväg. Kunden var så nöjd med resultatet att de godkände illustrationerna på stående fot.'}
      ],
      'textPin':'Illustrationer till sportflaska och musmatta.',
      'caseInputDate':'2015-05-07',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Produktillustrationer',
      'colorSpace':'4',
      'employer':'4',
      'client': '16',
      'imgCollage':'8',
      'imgCollageSetup':'67,64,66,65',
      'tools':'2',
      'tasks':'9,10,26',
      'format':'Illustrationer',
      'year':'2014',
      'imgThumb': {
        'img1': 'other/Telia/illustrationer/2x2-Telia-Mouse-01.jpg',
        'img2': 'other/Telia/illustrationer/2x1-Telia-Sport-02.jpg',
        'img3': 'other/Telia/illustrationer/1x1-Telia-Mouse-04.jpg',
      },
      'categories': {
        'other': true,
      }
    },
    {
      'id':'17',
      'show':'1',
      'headline':'Butikskampanj',
      'textShort':'Butikskampanj för Löfbergs Lila',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>2006 firade Löfbergs Lila 100år.<span> <span class="CapDown">I samband med det tog man fram ett par illustrationer som skulle representera de olika decennierna.</span>'},
        {'paragraph': 'Mitt uppdrag blev att ta fram mönsteroriginal till kopparna och de magneter som man skulle få i samband med kaffekoppsköpet.'},
        {'paragraph': 'Eftersom detta var en butikskampanj behövdes det även lådor och ställ. Magneterna skulle levereras i kartonger till butikerna och Löfbergs Lila ville han smart lösning som även stack ut lite och skapade intresse i butiken.'},
        {'paragraph': 'Tillsammans med min projektledaren arbetade vi fram en kartonglösning, där illustrationerna stack upp när man vek ner ovankanten på kartongen de fraktades i. Hela kartongen kunde man sedan sätta i en pelare, som vi också tog fram, eller ställa direkt på ett bord ihop med kaffekopparna.'},
      ],
      'textPin':'Butikskampanj för Löfbergs Lila.',
      'caseInputDate':'2015-05-19',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Butikskampanj',
      'colorSpace':'2',
      'employer':'2',
      'client': '8',
      'imgCollage':'2',
      'imgCollageSetup':'73,72',
      'tools':'1,2',
      'tasks':'9,25',
      'format':'Butiskpresentation<BR>Magneter<BR>Koppar',
      'year':'2006',
      'imgThumb': {
        'img1': 'print/Lofbergs/Butik/2x1-Lofbergs-Camp-03.jpg',
        'img2': 'print/Lofbergs/Butik/2x2-Lofbergs-campaign-01.jpg',
        'img3': 'print/Lofbergs/Butik/2x2-Lofbergs-campaign-02.jpg',
      },
      'categories': {
        'print': true,
      }
    },
    {
      'id':'18',
      'show':'1',
      'headline':'Informationsfilm',
      'textShort':' Informationsfilm till Friskis&Svettis',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>När Friskis&Svettis uppdaterade sin webbshop 2014<span> <span class="CapDown">gjordes det så många nya ändringar och tillägg att kundansvarig insåg att det bästa sättet att förklara alla ändringar var med en presentationsfilm.</span>'},
        {'paragraph': 'Tillsammans med vår AD och vår copywrighter jobbade vi fram en idé att göra den animerad i 3D. AD:n tog fram ett par skisser som jag kunde jobba vidare på och copyn skrev texterna som låg till grund för filmen. Sen var det upp till mig.'},
        {'paragraph': 'Det tog mig sex veckor från scratch att färdigställa filmen och hade även en del andra jobb som också skulle göras.'},
        {'paragraph': 'Deadline var lanseringsdagen för nya shoppen, så det var tight om tid.'},
        {'paragraph': 'Jag pushade verkligen mina kunskaper framåt, dels för att jag gjorde saker som jag aldrig gjort tidigare och samtidigt som jag skulle göra dem var jag tvungen att lära mig, dels hade jag en deadline, vilket gjorde att jag måste hitta kreativa lösningar för att inte bli sen.'},
        {'paragraph': 'Om jag inte minns fel, var jag klar kvällen innan, då hade jag en vecka tidigare hittat en renderingsfarm som hade ett bra erbjudande och som ökade produktionstakten märkbart mot slutet.'},
      ],
      'textPin':' Informationsfilm till Friskis&Svettis.',
      'caseInputDate':'2015-05-18',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Instruktionsfilm',
      'colorSpace':'1',
      'employer':'4',
      'client': '6',
      'imgCollage':'4',
      'imgCollageSetup':'68,69,70,71',
      'tools':'1,2,3,13',
      'tasks':'4,11,12,13,14,15,16,21,23,24,25',
      'format':'Instruktionfilm<BR>1920px x 1080px',
      'year':'2014',
      'link': [
        {
          'title': 'Se instruktionsfilmen på Vimeo',
          'icon': 'vimeo',
          'url': 'https//:vimeo.com128578317'
        }
      ],
      'imgThumb': {
        'img1': 'film/Friskis/Instruktionsfilm/2x1-Friskis-Instr-04.jpg',
        'img2': 'film/Friskis/Instruktionsfilm/2x1-Friskis-Instr-02.jpg',
        'img3': 'film/Friskis/Instruktionsfilm/2x1-Friskis-Instr-03.jpg',
      },
      'categories': {
        'film': true,
        '3d': true,
      }
    },
    {
      'id':'19',
      'show':'1',
      'headline':'Hangtags',
      'textShort':'Hangtags till produkter i hotellshopparna',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Varje Scandichotell har en liten butik i foajén.<span> <span class="CapDown">När Scandic skaffade sig ett nytt profil, blev vårt uppdrag att ta fram passande produkter till butikerna. Produkterna var av karaktären \'Jag glömde visst...hemma\'. Det var vinöppnare, klädborstar, sykit, badkläder, tvättpåsar med mera.</span>'},
        {'paragraph': 'Grundtanken var att de inte skulle förpackas utan man skulle direkt se vad som låg på hyllorna. Lösningen blev att sätta hangtags på alla produkterna.'},
        {'paragraph': 'Jag fick i uppdrag blev att ansvara för foto och retusch av alla produkterna, göra dem tryckfärdiga och montera dem på mallarna till hangtagsen.'},
        {'paragraph': 'Förutom produktfotograferingretush ansvarade jag även för originalhanteringen och kontakt med tryckeriet.'},
      ],
      'textPin':'Hangtags till produkter i hotellshopparna.',
      'caseInputDate':'2015-05-27',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Hangtags',
      'colorSpace':'2',
      'employer':'2',
      'client': '11',
      'imgCollage':'7',
      'imgCollageSetup':'99,100,101,102',
      'tools':'1,2,16',
      'tasks':'9,12,16,17,23',
      'format':'Hangtags<BR>Klisteretiketter',
      'year':'2008',
      'imgThumb': {
        'img1': 'print/Scandic/Hangtags/2x1-Scandic-Hangtags02.jpg',
        'img2': 'print/Scandic/Hangtags/2x2-Scandic-Hangtags01.jpg',
        'img3': 'print/Scandic/Hangtags/1x1-Scandic-Hangtags03.jpg'
      },
      'categories': {
        'print': true,
        'photo': true,
      }
    },
    {
      'id':'20',
      'show':'1',
      'headline':'Grafiskt mönster',
      'textShort':'Mönster till olika typer av produkter',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Ahlsell behövde grafik<span> <span class="CapDown">till sina produkter. Man ville förnya sig på något sätt men samtidigt ville man inte gå för långt. Det skulle vara en egen grafisk enhet för produkter, snarare än en ny profil för hela företaget. Och det skulle kännas \'Ahlselligt\'.</span>'},
        {'paragraph': 'Man hade redan använt sig av enfärgade rutmönster. Det jag gjorde var att vidareutveckla rutnätet, malla upp bilder och lägga till komplementfärger där det gavs möjlighet.'},
        {'paragraph': 'Många produkter kunde bara tryckas med enfärgstryck lösningen då blev ett raster som gjorde att färgen upplevdes som tonad.'},
        {'paragraph': 'Mönstret användes ett par år, innan man uppdaterade sig igen med nya grafiska element.'}
      ],
      'textPin':'Mönster till olika typer av produkter.',
      'caseInputDate':'2015-05-26',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Produktmönster','colorSpace':'5',
      'employer':'2',
      'client': '2',
      'imgCollage':'5',
      'imgCollageSetup':'82,80,81,83,84',
      'tools':'1,2,4',
      'tasks':'28,9,10,26,27',
      'format':'Produktmönster',
      'year':'2007',
      'imgThumb': {
        'img1': 'print/Ahlsell/Rutor/2x1-AHL-rutor-06.jpg',
        'img2': 'print/Ahlsell/Rutor/2x2-AHL-rutor-03.jpg',
        'img3': 'print/Ahlsell/Rutor/1x1-AHL-rutor-01.jpg'
      },
      'categories': {
        'print': true,
      }
    },
    {
      'id':'21',
      'show':'1',
      'headline':'Produktlåda',
      'textShort':'Mönster till produktlåda',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Ahlsells produktlåda<span> <span class="CapDown">gjordes utifrån det grafiska man\u00e9 som jag tog fram för Ahlsells produkter.</span>'},
        {'paragraph': 'Lådorna innehöll godis men kunde lika gärna användas för exempelvis golbollar eller vad man nu behöver vid olika event.'},
        {'paragraph': 'Det speciella med lådorna är den blandar fyrfärgstryck och Ahlsells blå Pantone-färg. Detta för att få fram den perfekta Ahlsell-blå nyansen.'},
        {'paragraph': 'Utmaningen var att få det övriga trycket att bli lika intensivt som en ren Pantone. Det tog några provtryck och skruvningar på mättnaden innan jag och kunden var nöjda.'},
      ],
      'textPin':'Mönster till produktlåda.',
      'caseInputDate':'2015-05-27',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Produktlåda',
      'colorSpace':'5',
      'employer':'2',
      'client': '2',
      'imgCollage':'2',
      'imgCollageSetup':'86,87',
      'tools':'1,2',
      'tasks':'9,10,16,25',
      'format':'Höjd: 232mm<BR>Bredd: 265mm<BR>Djup: 127mm',
      'year':'2007',
      'imgThumb': {
        'img1': 'print/Ahlsell/Kartong/2x1-AHL-Kartong-03.jpg',
        'img2': 'print/Ahlsell/Kartong/2x2-AHL-kartong-02.jpg',
        'img3': 'print/Ahlsell/Kartong/2x2-AHL-kartong-01.jpg'
      },
      'categories': {
        'print': true,
      }
    },
    // {
    //   'id':'22',
    //   'show':'1',
    //   'headline':'Logotypeer',
    //   'textShort':'Ett urval av logotypeer.',
    //   'textLong':'<span class=\'CapUp\'>Jag har fått frågan ett antal gånger<span> <span class="CapDown">om jag kan göra en logotype.\u00a0<BR><BR>Lite lätt och snabbt...<BR><BR>Det är inte så lätt som man tror. Man behöver göra ett ordentligt grundjobb och faktiskt värka ut logotypeen.<BR><BR>Det är många delar som ska höra ihop och framför allt tycker jag att den ska berätta en story om ägaren.\u00a0<BR><BR>Och om jag ska vara ärlig, så anser jag att jag hittills har gjort ett par bra jobb. Det finns en glädje i att se ett företag eller person få växa fram i en enda bild.<BR><BR>För mig ska en logotype berätta något om personenföretaget. Den ska helst kunna stå för sig själv, som en ikon. Och allra helst ska den ha en liten twist. <BR><BR> En logotype som inte finns här är till Ekoskoter, men du kan <h3>DANIJELA\u00a0RUNDQVIST</h3><p>Danijela är en god vän som behövde hjälp med sin blogg. Självklart fick hon en blogg och en logotype. Jag menar - klart att en hockeyhjältinna ska ha en ordentlig hockeylogotype.<BR><BR>Logotypeen har sitt ursprung från amerikanska hockeyvärlden med massiva bokstäver. Den har fått en svensk touch med gula stjärnor på blå \'ismoln\'. Q:et i Rundqvist har bytts ut mot en puck där ismolnen och stjärnorna blivit Q:ets svans. Stjärnorna representerar Danijelas fruktade slagskott.\u00a0<p><BR><BR><h3>NYREGISTRERING.SE</h3><p>Ett företag som tillhandahöll en tjänst där man månadsvis kunde få tillgång till nyregistrerade företag.\u00a0<BR><BR>Logotypeen utgår från bokstäverna n och r (ny\u00a0registering).\u00a0<BR><BR>Den \'studsande effekten\' från bokstäverna symboliserar att man behöver göra ett nedslag hos Nyregistrering.se för att kunna ta sig vidare till de intressanta företagen.\u00a0<p><BR><BR><h3>FATUHIVA\u00a0FILM</h3><p>Fatuhivas logotype hade en fristående figur i sin gamla logotype som jag renodlade och ramade in. Ramen är innerdelen av en filmcell, främst för att det är klich\u00e9aktigt med matarhål på en filmlogotype.\u00a0<p><BR><BR><h3>CHRISTIN\u00a0PHILIPSSON</h3><p>Christin är fotograf som behövde en enkel logotype och hon behövde den fort. Heslt skulle den vara lite personlig. Inget är bättre för kreativiteten än lite tidspress. Den mest personliga logotypeen man har är sin namnteckning. Varför inte? Det fick bli Christins autograf.\u00a0<BR><BR>För att göra det lite mer intressant ritade jag om den i 3D, vilket också gjorde att den fick en mjukare rundhet.<p></span>',
    //   'textPin':'Ett urval av logotypeer.',
    //   'caseInputDate':'2015-05-24',
    //   'showArt':'0',
    //   'quote':null,
    //   'quoteName':'',
    //   'type':'Logotypeer',
    //   'colorSpace':'1',
    //   'employer':'8',
    //   'imgCollage':'4',
    //   'imgCollageSetup':'76,77,78,79',
    //   'tools':'2,1,3',
    //   'tasks':'28,26,22',
    //   'format':'Vektorgrafik<BR>PNG<BR>JPG',
    //   'year':null,
    //   'link':null,
    //   'linkName':null,
    //   'imgThumb':'https://raw.githubusercontent.com/steffodimfelt/steffodimfelt.github.io/master/static/img/cases/other/2x1-Danni.jpg'
    // },
    {
      'id':'23',
      'show':'1',
      'headline':'Sommarpresent',
      'textShort':'Sommarpresent till anställda på Skandia',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Det första Skandia gjorde<span> <span class="CapDown">när de bytte sin profil, var att fråga efter en sommarpresent till alla anställda. Den skulle på något sätt binda ihop den nya profilen med sommar.</span>'},
        {'paragraph': 'Produktansvarig tog fram två \'bollar\' som skulle representera de två punkter som numera finns i Skandias logotyp.'},
        {'paragraph': 'Mitt uppdrag var att ta fram fotografera produkter och ta fram originalet till förpackningen.'},
      ],
      'textPin':'Sommarpresent till anställda på Skandia.',
      'caseInputDate':'2015-05-27',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Presentlåda',
      'colorSpace':'2',
      'employer':'2',
      'client': '12',
      'imgCollage':'7',
      'imgCollageSetup':'91,89,90,92',
      'tools':'1,2',
      'tasks':'9,10,16,25',
      'format':'Höjd: 330mm<BR>Bredd: 250mm<BR>Djup: 100mm',
      'year':'2008',
      'imgThumb': {
        'img1': 'print/Skandia/Sommarpres/2x1-Skandia-Summer-01.jpg',
        'img2': 'print/Skandia/Sommarpres/2x2-Skandia-Summer-03.jpg',
        'img3': 'print/Skandia/Sommarpres/1x1-Skandia-Summer-04.jpg'
      },
      'categories': {
        'print': true,
        'photo': true,
      }
    },
    {
      'id':'24',
      'show':'1',
      'headline':'Gör\'t Projektplanerare',
      'textShort':'En egenutvecklad projektplanerare',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Vad gör man när man snabbt behöver en projektplanerare?<span> <span class="CapDown">Svaret är att man helt enkelt bygger en själv.</span>'},
        {'paragraph': 'När jag var originalare på Stadium Promotion upptäckte vi att projekten ramlade in allt snabbare och vi fick allt mindre överblick om vem som var ansvarig för vad och vem som väntade på tillbakaspel och var projekten hade för tidsplan.'},
        {'paragraph': 'Att köpa in en projektplanerare är inte bara en kostnad, det är inte säkert att alla kommer att använda den, plus att den kanske inte passar i Stadium Promotions sätt att arbeta.'},
        {'paragraph': 'Mitt förslag blev att bygga en egen projektplanerare, som vi själva kunde anpassa till vårt arbetssätt och möjlighet att bygga ut efter behov. Jag hade vid tidpunkten för byggandet ännu inte lärt mig PHP varpå jag byggde den i Classic ASP, JavaScript och Access, under tre veckor (till och från eftersom jag hade andra tasks att sköta upptill).  Koderna kanske inte är de snyggaste och turerna kring att lägga in och ta bort poster är inte optimala, men med tanke på tiden så är jag nöjd med resultatet.'},
        {'paragraph': 'Gör\'t har en enkel struktur. Man lägger in sitt projekt, är det fler inblandade bockar man för deras namn, deras tasks och när man förväntar sig återspel från dessa personer. Man kan få upp en projektlista på alla projekt man själv har starta, men även de projekt som någon annan har startat och man själv är delaktig i. Ja, that\'s it! Mer än så hann jag inte med. Dock hade jag vidare planer på mejlfunktioner och grafisk projektstatus, men som sagt, tiden fanns inte.'},
        {'paragraph': 'Trots det antika ASP och att koppla ihop det med Access, är jag ändå nöjd med resultatet. De rådiga koderna syns inte utåt, som tur är. Det finns en tanke om att bygga om den i PHP och MySQL, men just nu har tiden inte räckt till.'},
        {'paragraph': 'Ordet Gör\'t är östsjötskt och betyder helt enkelt \'Gör det\' ocheller \'Redan gjort\'. Stadium var moderbolaget till Stadium Promotion och de satt i Norrköping.'},
      ],
      'textPin':'En egenutvecklad projektplanerare. ',
      'caseInputDate':'2015-05-28',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Projektplanerare',
      'colorSpace':'1',
      'employer':'2',
      'client': '13',
      'imgCollage':'3',
      'imgCollageSetup':'93,94,95',
      'tools':'22,21,10,11,7,1',
      'tasks':'7,8,10',
      'format':'Webbsida',
      'year':'2012',
      'imgThumb': {
        'img1': 'web/DoIt/2x1-DoIt-03.jpg',
        'img2': 'web/DoIt/2x1-DoIt-02.jpg',
        'img3': 'web/DoIt/2x2-DoIt-01.jpg'
      },
      'categories': {
        'web': true,
      }
    },
    {
      'id':'25',
      'show':'1',
      'headline':'Webbsida',
      'textShort':'Webbsida till Stadium Promotion',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Det var snabba ryck med att göra Stadium Promotions webbsida.<span> <span class="CapDown">Jag hade precis avslutat case-filmerna som skulle vara på sidan, sommaren var en vecka bort.</span>'},
        {'paragraph': 'Av erfarenhet vet jag att det är stört inpå omöjligt att byggga en schysst sida på en vecka. Det är stört på omöjligt. Ändå skulle det göras.'},
        {'paragraph': 'Som tur var fick jag bra underlag från min AD och Copy. Jag byggde sidan i Flash. Och fort gick det. Det var inte så många sidor som skulle göras.<BR><BR>På onsdag eftermiddag presenterade jag sidan. Vi upptäckte på en gång att sidan inte fungerade i alla läsare. Det behövdes göras en HTML5-variant. Jag satte genast igång att jag en konverterare.'},
        {'paragraph': 'Turligt nog för mig hade Google utvecklat en plugin till Flash som heter Swiffy. Den räddade mitt liv.'},
        {'paragraph': 'Fredag eftermiddag vid 18-tiden, kunde vi korkar upp champagnen och stå i Nöjdrutan över den nya snygga webbsidan och dess filmer.'}
      ],
      'textPin':'Webbsida till Stadium Promotion',
      'caseInputDate':'2015-05-28',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Webbsida',
      'colorSpace':'1',
      'employer':'2',
      'client': '13',
      'imgCollage':'6',
      'imgCollageSetup':'96,97,98',
      'tools':'14,23,19',
      'tasks':'7',
      'format':'Webbsida',
      'year':'2012',
      'imgThumb': {
        'img1': 'web/StadiumPromotion/Webb/2x2-SP-Webb-03.jpg',
        'img2': 'web/StadiumPromotion/Webb/2x1-SP-Webb-01.jpg',
        'img3': 'web/StadiumPromotion/Webb/2x1-SP-Webb-02.jpg'
      },
      'categories': {
        'web': true,
      }
    },
    {
      'id':'26',
      'show':'1',
      'headline':'Casefilmer',
      'textShort':'Casefilmer till Stadium Promotion',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>\'Hur snabbt kan en person göra sju företagsfilm?\'<span> <span class="CapDown">Svaret är tre och en halv månad (och då jobbade jag tidvis med andra tasks också).</span>'},
        {'paragraph': 'Filmerna var upprinnelsen i den process som pågått i nästan tre år på Stadium Promotion. Man ville omdefiniera det man lite slarvigt kallar för \'profilprodukter\' och istället slå sig in på en mer medveten del i marknadsföringsmixen och bli ett hållbart reklamalternativ. Vad är mer hållbart än en produkt, i bra kvalitet, som används dagligen?'},
        {'paragraph': 'Tillsammans med två andra medarbetare satte vi oss ner och spånade. En av idéerna som jag kom med var att göra korta filmer som repeterade sig själva. Fördelen med detta var att man kunde göra en kort film, men som kunde förlängas i en evig loop. Som alltid när det gäller vision och slutresultat, blev det några jämkningar, bland annat att just att filmerna skulle vara eviga loopar. Men att repetera filmerna fem sex gånger är tillräckligt.'},
        {'paragraph': 'En annan sak var också att de skulle vara roliga. Humor är en genväg till gillandet och vi hade en grundtanke till alla filmerna. Nu var det bara att sätta igång.'},
        {'paragraph': '\'Den som är ovetande om det omöjliga, gör det möjliga\' är en tanke så här efteråt. Visst - det fanns manus och idéer, men själva arbetsprocessen var mycket dynamisk, för att inte säga något obefintligt. Och det var nog det som gjorde det möjligt.'},
        {'paragraph': 'Jag fick använda alla medel och program för att ta mig igenom filmerna. De innehöll 3D-animeringar, rotoscoping, chroma key och lager på lager av compositing. Jag lärde mig en massa om arbetsflöden och tekniska utmaningar. Det var verkligen lärorikt att huvudstupa kasta sig ut för att lösa uppgiften innan semestern började.'},
        {'paragraph': 'Det blev bättre än jag trodde och med tanke på den snäva tidsramen är jag riktigt nöjd med resultatet. Det är klar - idag hade jag nog planerat och varit mer noggrann innan jag satte igång och testat lite, men samtidigt hade jag inte tid till det.'},
        {'paragraph': 'Det var roligt att få göra och det var verkligen fantastiskt att jag fick chansen att verkligen lära mig alla delar som man bara läser om eller ser bakom kulisserna.'},
      ],
      'textPin':'Casefilmer till Stadium Promotion',
      'caseInputDate':'2016-08-17',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Företagsfilmer',
      'colorSpace':'1',
      'employer':'2',
      'client': '13',
      'imgCollage':'4',
      'imgCollageSetup':'117,114,115,116',
      'tools':'1,2,3,5,6,12,13,15,18',
      'tasks':'29,28,1,2,3,4,10,11,12,13,14,16,20,21,22,23,24',
      'format':'MPEG-4H.264',
      'year':'2012',
      'link': [
        {
          'title': 'Se filmen Skandia Bricka',
          'icon': 'vimeo',
          'url': 'https://vimeo.com/130078551'
        },
        {
          'title': 'Se filmen Scandic Smörkniv',
          'icon': 'vimeo',
          'url': 'https://vimeo.com/130078425'
        },
        {
          'title': 'Se filmen Scandic Necessär',
          'icon': 'vimeo',
          'url': 'https://vimeo.com/130078427'
        },
      ],
      'imgThumb': {
        'img1': 'film/StadiumPromotion/Casefilmer/2x1-SP-Case-03.jpg',
        'img2': 'film/StadiumPromotion/Casefilmer/2x1-SP-Case-04.jpg',
        'img3': 'film/StadiumPromotion/Casefilmer/2x1-SP-Case-05.jpg'
      },
      'categories': {
        'film': true,
      }
    },
    {
      'id':'27',
      'show':'1',
      'headline':'Kylskåpsmagnet',
      'textShort':'Kylskåpsmagnet för Trisslotter',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Vissa saker ska man vara rädd om.<span> <span class="CapDown">Att tappa bort en miljon kan svida. Bäst att ta hand om den där Trisslotten. Den innehåller ju en dröm från vardagens sås och potatis. Och var passar inte bättre att drömma sig bort från mellanmjölken, än på utsidan på ett kylskåp?</span>'},
        {'paragraph': 'Till Svenska Spels Triss gjorde jag originalet till en magnet med en ficka avsedd för en Trisslott. Självklart är det det en lotten med miljonvinst som ska sitta där och hägra.'},
        {'paragraph': 'För plötsligt händer det...'}
      ],
      'textPin':'Kylskåpsmagnet för Trisslotter',
      'caseInputDate':'2015-06-08',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Kylskåpsmagnet',
      'colorSpace':'2',
      'employer':'2',
      'client': '15',
      'imgCollage':'3',
      'imgCollageSetup':'103,104,105',
      'tools':'2',
      'tasks':'9,27',
      'format':'Bredd: 68mm<BR>Höjd: 95mm',
      'year':'2008',
      'imgThumb': {
        'img1': 'print/SvenskaSpel/magnet/2x1-SvS-Magnet02.jpg',
        'img2': 'print/SvenskaSpel/magnet/2x2-SvS-Magnet01.jpg',
        'img3': 'print/SvenskaSpel/magnet/2x1-SvS-Magnet03.jpg'
      },
      'categories': {
        'print': true,
      }
    },
    {
      'id':'28',
      'show':'1',
      'headline':'Webbsida',
      'textShort':'Personlig webbsida till Pontus Olgim',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>När skådespelaren Pontus Olgrim<span> <span class="CapDown">behövde en ny webbsida, skickade han ett sms med frågan till mig. Det är egentligen inte så konstigt, han är min gode vän och jag gjorde hans webbsida redan 2010.</span>'},
        {'paragraph': 'Den nya sidan gjordes responsiv med allt innehåll på en sida istället för uppdelat på flera.'},
        {'paragraph': 'Det stora jobbet gjordes bakom kulisserna. Pontus vill själv kunna uppdatera allt på sidan när något nytt händer.'},
        {'paragraph': 'Min lösning blev en admin-del där Pontus exempelvis kan lägga upp nya jobb, ändra i alla texter, ladda upp nya bilder och ändra visningsläge för alla typeer av bilder på sidan.'},
        {'paragraph': 'Det ska tilläggas att det 2016 gjordes en uppdatering av sidan, baserat på mitt wireframe-tools <strong><a href=\'https://codepen.io/steffodimfelt/\'>Sluggo<a>.<strong>'}
      ],
      'textPin':'Personlig webbsida till Pontus Olgim',
      'caseInputDate':'2015-09-17',
      'showArt':'0',
      'quote':null,
      'quoteName':'',
      'type':'Webbsida',
      'colorSpace':'1',
      'employer':'9',
      'client': '10',
      'imgCollage':'2',
      'imgCollageSetup':'106,107',
      'tools':'25,19,11,24,8,9,1',
      'tasks':'28,7,8',
      'format':'Webbsida',
      'year':'2015',
      'link': [
        {
          'title': 'Besök sidan pontusolgrim.se',
          'icon': 'web',
          'url': 'http://pontusolgrim.se/'
        }
      ],
      'imgThumb': {
        'img1': 'web/PontusOlgrim/2015/2X1-Pontus-Portfolio-2015-03.jpg',
        'img2': 'web/PontusOlgrim/2015/2x2-Pontus-Portfolio-2015-01.jpg',
        'img3': 'web/PontusOlgrim/2015/2x2-Pontus-Portfolio-2015-02.jpg'
      },
      'categories': {
        'web': true,
      }
    },
    {
      'id':'29',
      'show':'1',
      'headline':'Teaterstycken',
      'textShort':'Två pjäser till Öppet Spår 2008 på Elverket',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Regissören Mikael Berg<span> <span class="CapDown">tog 2008 initiativet till Öppet Spår.  Två måndagskvällar på Elverket veks till ett antal enaktare och monologer, som tillsammans blev en helkväll på två timmmar.</span>'},
        {'paragraph': 'Mitt bidrag Parmiddagen, är en knapp halvtimmes färd från en trevlig parmiddag med karaoke, till ett nattsvart slut. Stor dos musik (alla medverkande hade sina musik-stundet) och lika stort dos med igenkänningsfaktorer.'},
        {'paragraph': 'Jag regisserade själv och var grymt nervös för den stundande premiären.'},
        {'paragraph': 'Jag blev uppringd  av Pontus Olgrim, som också ville vara med. Jag hade fullängdspjäs som hette Narcissus och den bantade jag ner till tio minuter och gjorde om den till ett kammarspel för två. Pontus spelade Narcissus och Anders Menzinsky spelade Brodern.'},
        {'paragraph': 'Pontus och jag gjorde senare en kortfilm av Narcissus.'},
        {'paragraph': 'Nu var jag dubbelt så nervös, med två bidrag på samma gång, men det gick över förväntan. Det var jättekul att få publiken att skratta och förfäras.'}
      ],
      'textPin':'Två pjäser till Öppet Spår 2008 på Elverket',
      'caseInputDate':'2015-09-27',
      'showArt':'0',
      'quote':null,'quoteName':'',
      'type':'Pjäser',
      'colorSpace':'6',
      'employer':'1',
      'client': '1',
      'imgCollage':'4',
      'imgCollageSetup':'109,110,111,112',
      'tools':'15',
      'tasks':'1,2',
      'format':'Pjäser',
      'year':'2008',
      'imgThumb': {
        'img1': 'other/OppetSpar-2008/2x1-Par-Nar-2008-02.jpg',
        'img2': 'other/OppetSpar-2008/2x1-Par-Nar-2008-01.jpg',
        'img3': 'other/OppetSpar-2008/2x1-Par-Nar-2008-03.jpg'
      },
      'categories': {
        'other': true,
        'event': true,
      }
    },
    {
      'id':'30',
      'show':'1',
      'headline':'Baktorget',
      'textShort':'En 3D-modellerad mössa till Bak&Choklad-mässan 2016',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>En av de mest besökta delarna av mässan Bak&Choklad<span> <span class="CapDown">var Baktorget - där medlemmar till branschorganisationen Sveriges bagare & konditorer stod och bakade under mässan.</span>'},
        {'paragraph': 'Designavdelningen på Stockholmsmässan hade jobbat fram montern och en av tankarna var att en konditormössa med SBKs logotype skulle blir kronan på verket. En riktig konditormössa var beställd och skulle fotas, men den dök inte upp och tiden var knapp. Att producera en fyra meter lång cirkelvepa tar tid.'},
        {'paragraph': 'Min lösning blev att istället modellera upp en konditormössa i 3D. I underlaget från Designavdelningen fanns ett lågupplöst foto på en mössa som jag använde som referens. Jag ville komma så nära den bilden som möjligt.'},
        {'paragraph': 'Det tog knappt tre timmar att modellera upp mössan, plus tre timmar att sätta rätt struktur och ljus. Eftersom bilden behövde vara stor var jag lite orolig för renderinstiden. Som tur var hade jag lite hjälp av en renderingsfarm allt som allt (med slutfix i Photoshop och slutmontering till tryckfärdigt original), tog det ca 8 timmar.'},
        {'paragraph': 'Jag fick stor uppskattning för slutresultatet. På Stockholmsmässans Designavdelning sa de att bilden gav en illusion av en riktig mössa.'},
      ],
      'textPin':'En 3D-modellerad mössa till Bak&Choklad-mässan 2016',
      'caseInputDate':'2016-10-15',
      'showArt':'1',
      'quote':'',
      'quoteName':'',
      'type':'3D-modell',
      'colorSpace':'2',
      'employer':'10',
      'client': '4',
      'imgCollage':'8',
      'imgCollageSetup':'120,119,121,118',
      'tools':'4,1,3 ',
      'tasks':'10,13,15,16',
      'format':'Cirkelvepa<BR>Bredd: 12540mm<BR>Höjd: 1500mm<BR><BR>Diskfront<BR>Bredd: 2020mm<BR>Höjd: 920mm',
      'year':'2016',
      'imgThumb': {
        'img1': '3d/Stockholmsmassan/BakChoklad/BoC-01.jpg',
        'img2': '3d/Stockholmsmassan/BakChoklad/BoC-02.jpg',
        'img3': '3d/Stockholmsmassan/BakChoklad/BoC-03.jpg'
      },
      'categories': {
        'print': true,
        '3d': true,
        'event': true,
      }
    },
    {
      'id':'31',
      'show':'1',
      'headline':'Editors\' Choice Award',
      'textShort':'Design av logotyp, emblem och diplom till Editors\' Choice Award',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Jag fick äran och möjligheten<span> <span class="CapDown">att designa logotyp, emblem och diplom till Editors\' Choice Award. Presigepriset delas ut under Stockholm Furniture & Light Fair i kategorierna Rising Star, Best Stand och Best Product. Juryn består av chefredaktörer från några av Europas viktigaste designforum.</span>'},  
        {'paragraph': 'Logotypen tar avstamp från vinnarstatyetten som är formgiven av den svenska designern Lisa Hilland. Den består av tre kuber i olika storlekar, där en av sidorna på varje kub är en spegel.'},
        {'paragraph': 'Man ville ha en modern, luftig och handritad känsla. Jag jobbade igenom logotypen i tre steg.'},
        {
          'subtitle': 'Steg 1',
          'paragraph': 'Jag började med att ta fram tre moodboards som var och en gav en känsla av design och modernt formspråk. Jag satt med de ansvariga för ECA och diskuterade idéer, tankar och mål.'
        },
        {
          'subtitle': 'Steg 2',
          'paragraph': 'Utifrån diskussionerna skissade jag upp ett antal utkast som skickades fram och tillbaka några gånger för justeringar och input.'
        },
        {
          'subtitle': 'Steg 3',
          'paragraph': 'En slutversion togs fram och färgsattes i en mörk grön färg som används i manualet till Furniture & Light Fair. Tanken var att färgen ändras från år till år.'
        },
        {
          'subtitle': 'Steg 4',
          'paragraph': 'Ett positivt och ett negativt grönt och vitt emblem togs fram. Dessutom gjorde jag även svartvita varianter. De olika emblemen är tänkta att att användas på olika medier - exempelvis är vita kuber på grön bakgrund tänkt att användas i sociala medier på nätet.'
        },  
        {
          'subtitle': 'Steg 5',
          'paragraph': 'Slutligen tog jag fram diplomet, där kukberna gjordes i guldvinyl som monterades för hand innan de ramades in. Juryn fick skriva sin namnteckningar.'
        },
        {
          'subtitle': 'Sammanfattning',
          'paragraph': 'Det blev lite pill, men hela projektet gick förvånansvärt smidigt. Jag är väldigt stolt över slutresultatet och jag vet att de ansvariga blev mycket nöjda.'
        },
      ],
      'textPin':'Design av logotype, emblem och diplom till Editors\' Choice Award',
      'caseInputDate':'2017-03-08',
      'showArt':'1',
      'quote':null,
      'quoteName':'',
      'type':'Logotype, emblem och diplom',
      'colorSpace':'5',
      'employer':'10',
      'client': '4',
      'imgCollage':'5',
      'imgCollageSetup':'122,123,124,125,126',
      'tools':'2,4',
      'tasks':'28,26,25',
      'format':'Diplom: A3-storlek<BR>Logotyper i varierande storlek. ',
      'year':'2017',
      'link': [
        {
          'title': 'Besök sidan Editors\' Choice Award 2017',
          'icon': 'web',
          'url': 'http//:www.stockholmfurniturelightfair.sevara-utstallningar-pa-stockholm-furniture---light-faireditors-choice-starteditors-choice-2017'
        }
      ],
      'imgThumb': {
        'img1': 'other/ECA/ECA-02.jpg',
        'img2': 'other/ECA/ECA-04.jpg',
        'img3': 'other/ECA/ECA-05.jpg'
      },
      'categories': {
        'print': true,
        'other': true,
        'event': true,
      }
    },
    {
      'id':'32',
      'headline':'Rateau Croupier',
      'textShort':'En träningsapp för croupier på kasinon',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Rateau Croupier är ett träningsverktyg för croupier på kasinon.<span> <span class="CapDown">Träningsdelen innehåller alla de olika moment som en croupier behöver öva för att bli bättre vid sin yrkesutövning.</span>'},
        {'paragraph': 'Appen är från början ett examensarbete från min YH-utbildning på Newton i Stockholm.'},
        {'paragraph': 'Appen lanserades under februari 2020 på Google Play.'},
        {'paragraph': 'Mina uppgifter är dels UX/UI-delen och dels att utveckla logiken till samtliga träningsdelar i React Native.'},
        {'paragraph': 'I den grafiska delen har jag jobbat mycket med 3D för att kunna införa ”äkta” kasinokänsla till Rateau Croupier.'},
      ],
      'caseInputDate':'2020-04-04',
      'type':'Mobil applikation',
      'colorSpace':'1',
      'employer':'1',
      'client': '1',
      'tools':'26,27,1,2,3',
      'tasks':'39,41,40,10,13,25',
      'format':'React Native för Android',
      'year':'2020',
      'link': [
        {
          'url': 'https://play.google.com/store/apps/details?id=com.rateaucroupier.rateaucroupier',
          'icon': 'google',
          'title': 'Ladda hem appen på Google Play'
        }
      ],
      'imgThumb': {
        'img1': 'mobile/croupier/3x1-croupier-01.jpg',
        'img2': 'mobile/croupier/2x2-croupier-02.jpg',
        'img3': 'mobile/croupier/2x2-croupier-03.jpg'
      },
      'categories': {
        'mobile': true,
      }
    },
    {
      'id':'33',
      'headline':'Challengize',
      'textShort':'Social träningsapp',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>För företaget Challengize<span> <span class="CapDown">gjorde jag en tre månaders praktikperiod. Här sattes jag i hetluften på på en gång som frontend-utvecklare.</span>'},
        {'paragraph': 'Tillsammans med Art Director och den fasta utvecklaren fick jag möjlighet att sätta det grafiska uttrycket.'},
        {'paragraph': 'Appen är byggd i React Native.'},
        {'paragraph': 'En av mina uppgifter blev att sätt ett stilmall för hela appen.'},
      ],
      'caseInputDate':'2020-04-04',
      'type':'Mobil applikation',
      'colorSpace':'1',
      'employer':'11',
      'client': '18',
      'tools':'26',
      'tasks':'39,40,41',
      'format':'React Native för både Android och iOS',
      'year':'2018',
      'link': [
        {
          'url': 'https://play.google.com/store/apps/details?id=com.challengize&gl=SE',
          'icon': 'google',
          'title': 'Ladda hem appen på Google Play'
        },
        {
          'url': 'https://apps.apple.com/se/app/challengize/id1376288953',
          'icon': 'apple',
          'title': 'Ladda hem appen på App Store'
        }
      ],
      'imgThumb': {
        'img1': 'mobile/challengize/3x1-challengize.jpg',
        'img2': 'mobile/challengize/2x2-challengize-02.jpg',
        'img3': 'mobile/challengize/2x2-challengize-03.jpg'
      },
      'categories': {
        'mobile': true,
      }
    },
    {
      'id':'34',
      'headline':'Strike Trading Cards',
      'textShort':'Gör dina egna digitala samlarkort',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Strike Trading Cards är en app<span> <span class="CapDown">där man själv kan göra sina egna samlarkort, som man sedan kan dela med sig till alla sina vänner.</span>'},
        {'paragraph': 'För Levels satt jag i en tre månader som frontend-praktikant och färdigställde de sista bitarna för iOS-appen i Swift. '},
      ],
      'caseInputDate':'2020-04-04',
      'type':'Mobil applikation',
      'colorSpace':'1',
      'employer':'12',
      'client': '19',
      'tools':'28',
      'tasks':'41',
      'format':'Swift för iOS',
      'year':'2019',
      'link': [
        {
          'url': 'https://apps.apple.com/se/app/strike-trading-cards/id1438521483',
          'icon': 'apple',
          'title': 'Ladda hem appen på App Store'
        }
      ],
      'imgThumb': {
        'img1': 'mobile/strike/3x1-strike.jpg',
        'img2': 'mobile/strike/2x2-strike-02.jpg',
        'img3': 'mobile/strike/2x2-strike-03.jpg'
      },
      'categories': {
        'mobile': true,
      }
    },
    {
      'id':'35',
      'headline':'Red Line Oil',
      'textShort':'En promotionapp för Red Line Oil',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Red Line Oil ville ha en enkel app<span> <span class="CapDown">för Android, där man bland annat snabbt kan hitta de viktigaste delarna i deras sortiment.</span>'},
        {'paragraph': 'Appen byggde jag i React Native på tio timmar.'},
      ],
      'caseInputDate':'2020-04-04',
      'type':'Mobil applikation',
      'colorSpace':'1',
      'employer':'13',
      'client': '20',
      'tools':'26',
      'tasks':'39,41',
      'format':'React Native för Android',
      'year':'2019',
      'link': [
        {
          'url': 'https://play.google.com/store/apps/details?id=com.redlineoil&gl=SE',
          'icon': 'google',
          'title': 'Ladda hem appen på Google Play'
        }
      ],
      'imgThumb': {
        'img1': 'mobile/redline/3x1-rlo.jpg',
        'img2': 'mobile/redline/2x2-rlo-01.jpg',
        'img3': 'mobile/redline/2x2-rlo-02.jpg'
      },
      'categories': {
        'mobile': true,
      }
    },
    {
      'id':'36',
      'headline':'Yellow',
      'textShort':'En mockup på en fiktiv mobil applikation',
      'textLong': [
        {'paragraph': '<span class=\'CapUp\'>Yellow är ett grupparbete inom UI/UX-delen<span> <span class="CapDown">på Newtons YH-utbildning för apputveckling.</span>'},
        {'paragraph': 'Arbetet gick ut på att ta fram ett koncept för ett fiktivt företag, i detta fallet en mäklarbyrå som heter Yellow.'},
        {'paragraph': 'Grundförutsättningarna för projektet var att ta sig igenom alla delar i en UI/UX-process - från idé, koncept, storyboards, personor, flödesschema, wireframes och slutligen en mockup.'},
        {'paragraph': 'Jag fick förtroendet att få göra den slutliga mockupen och dess formspråk.'},
      ],
      'caseInputDate':'2020-04-04',
      'type':'Mockup',
      'colorSpace':'1',
      'employer':'1',
      'client': '1',
      'tools':'27',
      'tasks':'39,40,28,29,10',
      'format':'UI-mockup i Adobe XD',
      'year':'2018',
      'link': [
        {
          'url': 'https://xd.adobe.com/view/3e7e2117-037c-4990-9099-f0f5e14f6ab7/?hints=off',
          'icon': 'xd',
          'title': 'Se skissen på XD Mockup'
        }
      ],
      'imgThumb': {
        'img1': 'mobile/yellow/3x1-yellow-01.jpg',
        'img2': 'mobile/yellow/2x2-yellow-01.jpg',
        'img3': 'mobile/yellow/2x2-yellow-02.jpg'
      },
      'categories': {
        'mobile': true,
      }
    },
    // {
    //   'id':'37',
    //   'headline':'Bookmaker',
    //   'textShort':'En bokningsapplikation',
    //   'textLong': [
    //     {'paragraph': '<span class=\'CapUp\'>The Bookmaker är en egenutvecklad skript<span> <span class="CapDown">för kunna lägga bokningar och se vad som är bokat. Byggd i jQuery och ECMA 6. Fungerar dynamiskt och byggd med ”mobile first” i åtanke.</span>'},
    //     {'paragraph': 'Vidareutvecklingen på den här är att koppla ihop med databas och att man ska kunna göra in- och utcheckning på samma dag. '},
    //   ],
    //   'caseInputDate':'2020-04-04',
    //   'type':'Mockup',
    //   'colorSpace':'1',
    //   'employer':'1',
    //   'client': '1',
    //   'tools':'7,24,29',
    //   'tasks':'39,40,41,28',
    //   'format':'En bokningsapplikation',
    //   'year':'2020',
    //   'link': [
    //     {
    //       'url': 'https://github.com/steffodimfelt/bookmaker',
    //       'icon': 'github',
    //       'title': 'GitHub'
    //     }
    //   ],
    //   'imgThumb': {
    //     'img1': '3d/Stockholmsmassan/BakChoklad/BoC-01.jpg',
    //     'img2': '3d/Stockholmsmassan/BakChoklad/BoC-02.jpg',
    //     'img3': '3d/Stockholmsmassan/BakChoklad/BoC-03.jpg'
    //   },
    //   'categories': {
    //     'mobile': true,
    //     'web': true,
    //   }
    // },
  ];
};